import { Record, List } from 'immutable';

import Hydrator from 'utils/Hydrator';
import Entity from './Entity';

const NetworkModelRecord = Record({
  id: 0,
  name: '',
  logoUrl: '',
  file: null,
  partnerUrl: null,
  entities: List(),
});

export default class NetworkModel extends NetworkModelRecord {
  static deserialize(jsonObject = {}) {
    if (!jsonObject) {
      return undefined;
    }

    const mapProperties = {
      entities: Hydrator.fromList(Entity.deserialize),
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new NetworkModel(hydrated);
  }

  normalize() {
    return this.merge({
      entities: this.get('entities', List()).map((entity) => entity.id),
    });
  }

  denormalize({ entities, teams, members }) {
    return this.merge({
      entities: this.entities.map((entityId) =>
        entities.get(entityId).denormalize({ teams, members }),
      ),
    });
  }
}
